import React from 'react'
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";

const Payment = ({style, className, ...props}) => {
    const window = useSelector(state => state?.getWindowSize);
    return (
        <svg
            width="22"
            height="20"
            viewBox="0 0 20 22"
            fill="none"
            className={className}
            style={style}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.3 13.6C16.7167 13.6 17.0875 13.4375 17.4125 13.1125C17.7375 12.7875 17.9 12.4125 17.9 11.9875C17.9 11.5625 17.7375 11.1917 17.4125 10.875C17.0875 10.5583 16.7167 10.4 16.3 10.4C15.8833 10.4 15.5125 10.5583 15.1875 10.875C14.8625 11.1917 14.7 11.5625 14.7 11.9875C14.7 12.4125 14.8625 12.7875 15.1875 13.1125C15.5125 13.4375 15.8833 13.6 16.3 13.6ZM4.5 18.175V19.5V4.5V18.175ZM4.5 21C4.11667 21 3.77083 20.85 3.4625 20.55C3.15417 20.25 3 19.9 3 19.5V4.5C3 4.11667 3.15417 3.77083 3.4625 3.4625C3.77083 3.15417 4.11667 3 4.5 3H19.5C19.9 3 20.25 3.15417 20.55 3.4625C20.85 3.77083 21 4.11667 21 4.5V7.85H19.5V4.5H4.5V19.5H19.5V16.175H21V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM13.45 16.675C12.8833 16.675 12.4333 16.5083 12.1 16.175C11.7667 15.8417 11.6 15.4 11.6 14.85V9.175C11.6 8.60833 11.7667 8.1625 12.1 7.8375C12.4333 7.5125 12.8833 7.35 13.45 7.35H20.2C20.7667 7.35 21.2167 7.5125 21.55 7.8375C21.8833 8.1625 22.05 8.60833 22.05 9.175V14.85C22.05 15.4 21.8833 15.8417 21.55 16.175C21.2167 16.5083 20.7667 16.675 20.2 16.675H13.45ZM20.55 15.175V8.85H13.1V15.175H20.55Z"
                fill={window.color === 'Payments' ? "#059492" : "#737373"}/>
        </svg>
    )
}


Payment.propTypes = {
    fill: PropTypes.string
};

export default Payment
